import React from 'react';
export const ModalContext = React.createContext({});

export const ModalProvider = ({ children }) => {
  const [onCloseCallback, setOnCloseCallback] = React.useState(null);

  const value = {
    onCloseCallback,
    setOnCloseCallback,
  };
  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
